export default [
  {
    title: "Java List ☕️",
    description:
      "Java is a versatile, high-level programming language that was developed by Sun Microsystems (now owned by Oracle) in 1995. It is designed to be platform-independent, meaning that code written in Java can run on any device that has a Java Virtual Machine (JVM). Java is widely used for building large-scale enterprise applications, Android apps, web applications, and more. Its strong object-oriented design, robustness, and security features make it one of the most popular and reliable programming languages in the world. With its write once, run anywhere philosophy, Java continues to be a cornerstone of software development.",
    items: [
      {
        image: "https://img.youtube.com/vi/u57VAUB3f9U/maxresdefault.jpg",
        name: "Movie Booking Web-Site",
        href: "https://youtu.be/u57VAUB3f9U?si=MhUNLgmrpe9HKo1L",
        count: 1,
        route: "/sections/page-sections/page-headers",
      },
      {
        image: "https://img.youtube.com/vi/Zn00rcRz7Xs/maxresdefault.jpg",
        name: "Responsive Registration Form",
        href: "https://youtu.be/Zn00rcRz7Xs?si=ta1OR7cOO-VT-UkS",
        count: 1,
        route: "/sections/page-sections/features",
      },
      {
        image: "https://img.youtube.com/vi/2fgYoAyPUcE/maxresdefault.jpg",
        name: "Construction Billing System",
        href: "https://youtu.be/2fgYoAyPUcE?si=7RBVifP1d3Zd6cmb",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/R7CHH4co6VI/maxresdefault.jpg",
        name: "Library Management System",
        href: "https://youtu.be/R7CHH4co6VI?si=VOMlRZeQ1bqPwD2z",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/jkmROmvNwaU/maxresdefault.jpg",
        name: "Login Form Design",
        href: "https://youtu.be/jkmROmvNwaU?si=jyBMw0_4paSgW9c5",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/TyWzhGuSjpU/maxresdefault.jpg",
        name: "Business Contact Form",
        href: "https://youtu.be/TyWzhGuSjpU?si=ZZoodSVE_RTiHxDw",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/U0akBKITlyc/maxresdefault.jpg",
        name: "E-Banking System",
        href: "https://youtu.be/U0akBKITlyc?si=uOARrP-LIUnhp-n9",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/lale4fLXPqo/maxresdefault.jpg",
        name: "Racing Car Game Challenge",
        href: "https://youtu.be/lale4fLXPqo?si=DzgBy94RGZlDxLDr",
        count: 1,
      },
    ],
  },
  {
    title: "Python List 🐍",
    description:
      "Python is a high-level, interpreted programming language known for its simplicity and readability. Developed by Guido van Rossum and first released in 1991, Python emphasizes code readability with its clean and easy-to-understand syntax. It supports multiple programming paradigms, including procedural, object-oriented, and functional programming. Python's extensive standard library and rich ecosystem of third-party packages make it a versatile language used in various domains such as web development, data analysis, artificial intelligence, machine learning, automation, and more. Its ease of use and flexibility have made Python one of the most popular programming languages in the world.",
    items: [
      {
        image: "https://img.youtube.com/vi/RKgkkgiTj58/maxresdefault.jpg",
        name: "Sniper Game Project",
        href: "https://youtu.be/RKgkkgiTj58?si=SnaxmuSm4eNboO24",
        count: 1,
        route: "/sections/navigation/navbars",
      },
      {
        image: "https://img.youtube.com/vi/_kNDOMyksWg/maxresdefault.jpg",
        name: "Scientific Calculator Mobile App",
        href: "https://youtu.be/RKgkkgiTj58?si=SnaxmuSm4eNboO24",
        count: 1,
        route: "/sections/navigation/nav-tabs",
      },
      {
        image: "https://img.youtube.com/vi/_xKRFmE54hw/maxresdefault.jpg",
        name: "Smart Weather App",
        href: "https://youtu.be/_xKRFmE54hw?si=PP0mKFbVKnieDc2w",
        count: 1,
        route: "/sections/navigation/pagination",
      },
      {
        image: "https://img.youtube.com/vi/RgWbqUR7ho8/maxresdefault.jpg",
        name: "AI Assistant Chat App",
        href: "https://youtu.be/RgWbqUR7ho8?si=bb7hASkiW15Emv4v",
        count: 1,
        route: "/sections/navigation/pagination",
      },
      {
        image: "https://img.youtube.com/vi/3x-ev353jfA/maxresdefault.jpg",
        name: "Simple Music Player",
        href: "https://youtu.be/3x-ev353jfA?si=6mvlm_Ph9WakBIKb",
        count: 1,
        route: "/sections/navigation/pagination",
      },
      {
        image: "https://img.youtube.com/vi/bler8yeZhiI/maxresdefault.jpg",
        name: "Real Image Convert to Pencil Sketch",
        href: "https://youtu.be/bler8yeZhiI?si=52Pa4dH72ZQCT0Wu",
        count: 1,
        route: "/sections/navigation/pagination",
      },
      {
        image: "https://img.youtube.com/vi/bwd_frndXAw/maxresdefault.jpg",
        name: "Awesome Turtle Graphics",
        href: "https://youtu.be/bwd_frndXAw?si=D3xV_dkdY8KDElkj",
        count: 1,
        route: "/sections/navigation/pagination",
      },
      {
        image: "https://img.youtube.com/vi/uj98U-oLDo0/maxresdefault.jpg",
        name: "How To Build Best Chat-App ",
        href: "https://youtu.be/uj98U-oLDo0?si=xbdf_HhXWm08nlUZ",
        count: 1,
        route: "/sections/navigation/pagination",
      },
    ],
  },
  {
    title: "C++ List 💻",
    description:
      "C++ is a high-performance, versatile programming language developed by Bjarne Stroustrup in the early 1980s as an extension of the C language. It is widely used for system/software development, game development, and high-performance applications due to its ability to provide low-level memory manipulation while maintaining object-oriented programming features. C++ supports various programming paradigms, including procedural, object-oriented, and generic programming, making it a powerful tool for creating efficient and complex software solutions. It is renowned for its performance and control over system resources, making it a preferred choice for developing applications that require high-speed processing and resource management.",
    items: [
      {
        image: "https://img.youtube.com/vi/oVjoehkl7I4/maxresdefault.jpg",
        name: "AI Assistant Introduces the Vesak Festival",
        href: "https://youtu.be/oVjoehkl7I4?si=WxOPK-0s7yLUEMxA",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/9Uw8acxIWsY/maxresdefault.jpg",
        name: "Hotel Management System",
        href: "https://youtu.be/9Uw8acxIWsY?si=LQGAII-JUiLde4aD",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/vJRtcTykD48/maxresdefault.jpg",
        name: "Event Planning Billing System",
        href: "https://youtu.be/vJRtcTykD48?si=pgjqG7whDLRTwkoF",
        count: 1,
        route: "/sections/input-areas/forms",
      },
      {
        image: "https://img.youtube.com/vi/XVNqmrClSBE/maxresdefault.jpg",
        name: "Modern Airline Login Form",
        href: "https://youtu.be/XVNqmrClSBE?si=BnyiOP3ih876vIjn",
        count: 1,
        route: "/sections/input-areas/inputs",
      },
      {
        image: "https://img.youtube.com/vi/1aWvESauC9o/maxresdefault.jpg",
        name: "New Year Graphic Animation",
        href: "https://youtu.be/1aWvESauC9o?si=FuF1ZzZmZO9lyVpv",
        count: 1,
        route: "/sections/input-areas/inputs",
      },
      {
        image: "https://img.youtube.com/vi/bwd_frndXAw/maxresdefault.jpg",
        name: "Master the Basics: Essential Programme",
        href: "https://youtu.be/bwd_frndXAw?si=D3xV_dkdY8KDElkj",
        count: 1,
        route: "/sections/input-areas/inputs",
      },
      {
        image: "https://img.youtube.com/vi/uj98U-oLDo0/maxresdefault.jpg",
        name: "Happy Labour Day Celebrations",
        href: "https://youtu.be/uj98U-oLDo0?si=xbdf_HhXWm08nlUZ",
        count: 1,
        route: "/sections/input-areas/inputs",
      },
    ],
  },
  {
    title: "Flutter List 🦋",
    description:
      "Flutter is an open-source UI toolkit created by Google for building natively compiled applications for mobile, web, and desktop from a single codebase. It uses the Dart programming language and provides a rich set of pre-designed widgets and tools that make it easy to create beautiful, responsive, and high-performance applications. Flutter’s hot-reload feature allows developers to see changes in real-time, making the development process faster and more efficient. With its powerful and flexible architecture, Flutter is widely used for building cross-platform apps that look and feel native.",
    items: [
      {
        image: "https://img.youtube.com/vi/fwrgVinGr54/maxresdefault.jpg",
        name: "Online Food Ordering Mobile App",
        href: "https://youtu.be/fwrgVinGr54?si=ugTOks7ttAGDZnKC",
        count: 1,
        route: "/sections/attention-catchers/alerts",
      },
      {
        image: "https://img.youtube.com/vi/JdvDGVS20WE/maxresdefault.jpg",
        name: "Food Ordering Mobile App",
        href: "https://youtu.be/JdvDGVS20WE?si=Rz_E8NPoZfviWzBE",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/PT4ipPYW5Jo/maxresdefault.jpg",
        name: "A Full-stack Food Ordering App",
        href: "https://youtu.be/PT4ipPYW5Jo?si=58IDfQUCENxRiOBJ",
        count: 1,
        route: "/sections/attention-catchers/tooltips-popovers",
      },
      {
        image: "https://img.youtube.com/vi/aEWOxfS0s5U/maxresdefault.jpg",
        name: "How To Create Mobile Game App",
        href: "https://youtu.be/aEWOxfS0s5U?si=f7WFzcY5sOZrB46R",
        count: 1,
        route: "/sections/attention-catchers/modals",
      },
      {
        image: "https://img.youtube.com/vi/RoKzHCTnyw8/maxresdefault.jpg",
        name: "Gender Identification Mobile App",
        href: "https://youtu.be/RoKzHCTnyw8?si=RJabNUUZhNJ33HpN",
        count: 1,
        route: "/sections/attention-catchers/modals",
      },
      {
        image: "https://img.youtube.com/vi/lKVQHzlUWE4/maxresdefault.jpg",
        name: "Design a Splash screen",
        href: "https://youtu.be/lKVQHzlUWE4?si=J68qJker5v3FTVm3",
        count: 1,
        route: "/sections/attention-catchers/modals",
      },
      {
        image: "https://img.youtube.com/vi/xmgt116I4z4/maxresdefault.jpg",
        name: "Mobile Images Slider",
        href: "https://youtu.be/xmgt116I4z4?si=TIdvF9TLYae8d7St",
        count: 1,
        route: "/sections/attention-catchers/modals",
      },
      {
        image: "https://img.youtube.com/vi/4vGJuFHyC6w/maxresdefault.jpg",
        name: "Simple Mobile App",
        href: "https://youtu.be/4vGJuFHyC6w?si=1eKCtC-v_-8KR71R",
        count: 1,
        route: "/sections/attention-catchers/modals",
      },
    ],
  },
  {
    title: "C# List 🎯",
    description:
      "C# is a modern, object-oriented programming language developed by Microsoft as part of its .NET framework. First released in 2000, C# is designed for building a wide range of applications, from desktop software to web and mobile applications. It combines the robustness of C++ with the simplicity of Visual Basic, offering features like strong type-checking, garbage collection, and a rich set of libraries. C# supports component-oriented programming and is known for its powerful features and flexibility, making it a popular choice for developers working with Microsoft's ecosystem.",
    items: [
      {
        image: "https://img.youtube.com/vi/Lqom3Fejhuk/maxresdefault.jpg",
        name: "Online Food Delivery Management System",
        href: "https://youtu.be/Lqom3Fejhuk?si=o9fd3cR9Ci90r7Y-Z",
        count: 1,
        route: "/sections/elements/buttons",
      },
      {
        image: "https://img.youtube.com/vi/VMrFU5u0EDQ/maxresdefault.jpg",
        name: "Blind-Supporter C# .Net Web App",
        href: "https://youtu.be/VMrFU5u0EDQ?si=3mL8a0S0Dqpfb1eB",
        count: 1,
        route: "/sections/elements/avatars",
      },
      {
        image: "https://img.youtube.com/vi/5fubYeKQP94/maxresdefault.jpg",
        name: "Responsive Garbage Collection Web-Site",
        href: "https://youtu.be/uj98U-oLDo0?si=xbdf_HhXWm08nlUZ",
        count: 1,
        route: "/sections/elements/dropdowns",
      },
      {
        image: "https://img.youtube.com/vi/y7agF1MdpX4/maxresdefault.jpg",
        name: "Responsive Portfolio Web Design",
        href: "https://youtu.be/y7agF1MdpX4?si=Xvq5E12zzuQXVOmo",
        count: 1,
        route: "/sections/elements/toggles",
      },
      {
        image: "https://img.youtube.com/vi/TFaRPKP7S0Q/maxresdefault.jpg",
        name: "Amazing Cartoon Web Store",
        href: "https://youtu.be/TFaRPKP7S0Q?si=A3Es9hvy5T5IhE-1",
        count: 1,
      },
      {
        image: "https://img.youtube.com/vi/UI3Y3mEaWz4/maxresdefault.jpg",
        name: "Airline Management Website",
        href: "https://youtu.be/UI3Y3mEaWz4?si=wBNjkezU9kl8oaRp",
        count: 1,
        route: "/sections/elements/breadcrumbs",
      },
      {
        image: "https://img.youtube.com/vi/xZhTb1FY6Co/maxresdefault.jpg",
        name: "Vehicle Service System Website",
        href: "https://youtu.be/xZhTb1FY6Co?si=4fn07kQyd9OPqY2Q",
        count: 1,
        route: "/sections/elements/badges",
      },
      {
        image: "https://img.youtube.com/vi/6U0TSjloTdQ/maxresdefault.jpg",
        name: "Simple Login Web Application",
        href: "https://youtu.be/6U0TSjloTdQ?si=uO1S8z-pYzbwee3r",
        count: 1,
        route: "/sections/elements/progress-bars",
      },
    ],
  },
];
